export default __webpack_public_path__ + "e3a6a3e43519c4a0e5af8da2c59ed094.png";